'use es6';

import { useQuery } from '../utils/DataFetchingClient';
import { useSelector } from 'react-redux';
import { pick } from 'underscore';
import { replaceCategoriesWithSubs, replaceHubWithTools } from '../api/TracksApi';
import { TRACKS_LESSONS_SEARCH } from '../queries/tracksLessonsSearchQuery';
import { getAugmentedTracksLessonsSubset } from '../selectors/trackAndLessonSortingSelectors';
import { useAllProgress } from '../features/userProgress';
import { getTracksAreRequesting } from '../selectors/trackSelectors';
import { getLessonsAreRequesting } from '../selectors/lessonSelectors';
const categoryToSearchQuery = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service'
};
const toolToSearchQuery = {
  MARKETING_HUB_TOOLS: 'marketing',
  SALES_HUB_TOOLS: 'sales',
  SERVICE_HUB_TOOLS: 'service'
};
export default function useTracksLessonsSearchQuery({
  durations,
  languages,
  categories,
  hubSpotSoftware,
  levels,
  contentTypes,
  search,
  partnersOnly
}, skip = false) {
  const getSearchTermFromCategory = () => {
    return categories && categories.length && categoryToSearchQuery[categories[0]] || hubSpotSoftware && hubSpotSoftware.length && toolToSearchQuery[hubSpotSoftware[0]];
  };

  const {
    allProgress,
    allProgressLoading,
    allProgressError
  } = useAllProgress(null);
  const {
    loading,
    data,
    error
  } = useQuery(TRACKS_LESSONS_SEARCH, {
    variables: pick({
      durations,
      languages,
      categories: replaceCategoriesWithSubs(categories || []),
      hubSpotSoftware: replaceHubWithTools(hubSpotSoftware || []),
      levels,
      contentTypes,
      search: search || getSearchTermFromCategory(),
      partnersOnly
    }, value => Array.isArray(value) ? value.length : !!value),
    skip
  });
  const augmentedTracksLessonsSearchQueryData = useSelector(state => getAugmentedTracksLessonsSubset(state, {
    tracksLessonsSubset: data || []
  }));
  const tracksRequesting = useSelector(getTracksAreRequesting);
  const lessonsRequesting = useSelector(getLessonsAreRequesting);
  const tracksLessonsSearchQueryData = augmentedTracksLessonsSearchQueryData.filter(item => item.data).map(item => {
    let status = 'NOT_STARTED';

    if (allProgress) {
      const basicItemType = item.contentType === 'TRACK' ? 'TRACK' : 'LESSON';
      const itemProgress = allProgress.assetProgress.find(asset => asset.id === item.id && asset.type === basicItemType);
      status = itemProgress ? itemProgress.status : 'NOT_STARTED';
      return Object.assign({}, item, {}, itemProgress, {
        status
      });
    }

    return Object.assign({}, item, {
      status
    });
  });
  return {
    tracksLessonsSearchQueryLoading: loading || allProgressLoading || tracksRequesting || lessonsRequesting,
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryError: error || allProgressError
  };
}